import { apiDelete, apiGet, apiPost, apiPut } from './api';

export async function getAllTemplates() {
  const result = await apiGet('/templates');
  return result.data || [];
}

export async function getTemplateById(id) {
  const result = await apiGet(`/templates/${id}`);
  return result.data || null;
}

export async function saveCustomTemplate(data) {
  const result = await apiPost('/templates', data);
  return result.data;
}

export async function updateTemplate(id, data) {
  const result = await apiPut(`/templates/${id}`, data);
  return result.data;
}

export async function deleteTemplate(id) {
  await apiDelete(`/templates/${id}`);
}

export function isDefaultTemplate(id) {
  return String(id).startsWith('default-');
}

export function isCustomTemplate(id) {
  return !isDefaultTemplate(id);
}

export const emptyTemplateForm = {
  title: '',
  category: '',
  coverImg: '',
  url: '',
  desc: '',
};

export function templateToForm(item) {
  return {
    title: item.title || '',
    category: item.category || '',
    coverImg: item.coverImg || '',
    url: item.url || '',
    desc: item.desc || '',
  };
}
